import axios from "axios";
import { useEffect, useState } from "react";
import { BASE_URL } from "../../api";
import { Link, useNavigate, useLocation } from "react-router-dom";
import MessageToster from "../../component/MessageToster";
import Loader from "../../component/Loader";
import CustomSelect from "../../component/CustomSelect";
import { validateOTP, validateRegisterFields } from "../../utils/validation";

export default function Register() {
  const navigate = useNavigate()
  const location = useLocation();
  const [showpass, setShowpass] = useState(false)
  const [loading, setLoading] = useState(false);
  const [beforReg, setBeforReg] = useState(false)
  const [country, setCountry] = useState([]);
  const [countrycode, setCountrycode] = useState([]);
  //   const [country, setCountry] = useState("");
  // const [countrycode, setCountrycode] = useState("");
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [timer, setTimer] = useState(60);
  const [canResend, setCanResend] = useState(false);
  const [resending, setResending] = useState(false);

  useEffect(() => {
    let interval;
    if (beforReg && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setCanResend(true);
    }
    return () => clearInterval(interval);
  }, [beforReg, timer]);

  const formatTimer = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins < 10 ? "0" : ""}${mins}:${secs < 10 ? "0" : ""}${secs}`;
  };

  const [input, setInput] = useState({
    fname: '',
    lname: '',
    email: '',
    password: '',
    mobile: '',
    otp: '',
    country: '',
    country_code: '',
    refercode: ''
  });
  const [validations, setValidations] = useState({
    fname: '',
    lname: '',
    email: '',
    password: '',
    mobile: '',
    otp: '',
    country: '',
    country_code: '',
    refercode: '',
    ibname: '',
    yearofexp: '',
    existclients: '',
    avgvolume: ''
  });

  const [showIBFields, setShowIBFields] = useState(false);

  const [ibData, setIbData] = useState({
    ibname: "",
    yearofexp: "",
    existclients: "",
    avgvolume: ""
  });

  const handelIBInputs = (e) => {
    const { name, value } = e.target;
    setIbData(prev => ({ ...prev, [name]: value }));
    setValidations(prev => ({ ...prev, [name]: "" }));
  };

  // const handelInputs = (e) => {
  //   const { name, value } = e.target;
  //   setInput({ ...input, [name]: value });
  //   setValidations({ ...validations, [name]: false });
  // };

  const handelInputs = (e) => {
    const { name, value } = e.target;

    if (name === "country_code") {
      const newCountry = Array.isArray(countrycode)
        ? countrycode.find(c => c.country_code === value)
        : null;

      setInput(prev => ({
        ...prev,
        country_code: value,
        mobile: newCountry
          ? prev.mobile.slice(0, newCountry.phone_code_length)
          : prev.mobile
      }));

      setValidations(prev => ({ ...prev, mobile: "", country_code: "" }));

      return;
    }

    if (name === "mobile") {
      const onlyNumbers = value.replace(/\D/g, "");

      const maxLen = selectedCountry?.phone_code_length || 10;

      if (onlyNumbers.length > maxLen) return;

      setInput(prev => ({ ...prev, mobile: onlyNumbers }));

      const regex = new RegExp(`^\\d{${maxLen}}$`);

      if (!regex.test(onlyNumbers)) {
        setValidations(prev => ({
          ...prev,
          mobile: `Mobile number must be exactly ${maxLen} digits`
        }));
      } else {
        setValidations(prev => ({ ...prev, mobile: "" }));
      }

      return;
    }

    if (name === "country") {
      const matchedCountryCode = Array.isArray(countrycode)
        ? countrycode.find(
            c =>
              c.country_name?.toLowerCase() === value?.toLowerCase() ||
              c.country_code?.toLowerCase() === value?.toLowerCase()
          )?.country_code
        : null;

      setInput(prev => ({
        ...prev,
        country: value,
        country_code: prev.country_code || matchedCountryCode || prev.country_code
      }));
      setValidations(prev => ({ ...prev, country: "" }));
      return;
    }

    setInput(prev => ({ ...prev, [name]: value }));
    setValidations(prev => ({ ...prev, [name]: "" }));
  };

  // const handelInputs = (e) => {
  //   const { name, value } = e.target;
  //   const updated = { ...input, [name]: value };
  //   setInput(updated);

  //   const errors = validateRegisterFields(updated, showIBFields, ibData);
  //   setValidations(errors);
  // };

  const getCountryData = async () => {
    setLoading(true)
    try {
      const res = await axios.get(`${BASE_URL}/account/country_data`);
      setCountry(res.data.country_name)
      // setCountrycode(res.data.country_data)

      const countryCode = res.data.country_data;
      setCountrycode(Array.isArray(countryCode) ? countryCode : Object.values(countryCode));

    } catch (err) {
      MessageToster("error", err.message || "Failed to load countries");
    } finally {
      setLoading(false);
    }
  }
  const handelSubmit = async () => {
    const errors = validateRegisterFields(input, showIBFields, ibData);
    setValidations(errors);

    // if (Object.keys(errors).length > 0) return;

    const hasErrors = Object.values(errors).some(Boolean);
    if (hasErrors) return;

    const maxLen = selectedCountry?.phone_code_length || 10;

    if (input.mobile.length !== maxLen) {
      setValidations(prev => ({
        ...prev,
        mobile: `Mobile number must be exactly ${maxLen} digits`
      }));
      return;
    }

    await AddClient();
  };

  const AddClient = async () => {
    setLoading(true);

    const formdata = {
      email: input.email,
      mobileno: input.mobile,
      otype: "REGISTER"
    }
    try {

      const res = await axios.post(`${BASE_URL}/account/before_register`, formdata);

      if (res.data.code === 200) {
        MessageToster("success", res.data.message);
        sessionStorage.setItem("token", res.data.user_id);
        setBeforReg(true);
        setTimer(60);
        setCanResend(false);
      } else {
        MessageToster("error", res.data.message);
        const msg = (res.data?.message || "").toLowerCase();
        if (msg.includes("mobile") || msg.includes("phone")) {
          setValidations(prev => ({ ...prev, mobile: res.data.message }));
        } else if (msg.includes("email") || msg.includes("already") || msg.includes("exist") || msg.includes("user")) {
          setValidations(prev => ({ ...prev, email: res.data.message }));
        }
      }
    } catch (err) {
      MessageToster("error", err.message || "Registration step failed");
    } finally {
      setLoading(false);
    }
  }

  const handleResendOTP = async () => {
    if (!canResend || resending || loading) return;
    setResending(true);
    try {
      const formdata = {
        email: input.email,
        mobileno: input.mobile,
        otype: "REGISTER"
      };

      const res = await axios.post(`${BASE_URL}/account/before_register`, formdata);

      if (res.data.code === 200) {
        MessageToster("success", res.data.message || "OTP resent successfully");
        setTimer(60);
        setCanResend(false);
        setInput(prev => ({ ...prev, otp: "" }));
        setValidations(prev => ({ ...prev, otp: "" }));
      } else {
        MessageToster("error", res.data.message || "Failed to resend OTP");
      }
    } catch (err) {
      MessageToster("error", err.message || "Failed to resend OTP");
    } finally {
      setResending(false);
    }
  };

  const submitForm = async () => {
    const matchedCountry = Array.isArray(countrycode)
      ? countrycode.find(c => c.country_code === input.country_code)
      : null;

    const phoneCode = matchedCountry?.phone_code || input.country_code;

    const bodyData = {
      email: input.email.toString(),
      password: input.password.toString(),
      mobileno: input.mobile,
      verifycode: input.otp,
      fname: input.fname,
      lname: input.lname,
      country: input.country,
      country_code: phoneCode,
      // phone_code: phoneCode,
      sloginid: input.refercode || "",
      iib: showIBFields ? 1 : 0,
      yearofexp: ibData.yearofexp || "0",
      // companyname: input.companyName,  // IB Name
      companyname: ibData.ibname || "",
      existclients: ibData.existclients || "0",
      avgvolume: ibData.avgvolume || "0"
    };

    setLoading(true);

    const otpErrors = validateOTP(input.otp);
    if (Object.keys(otpErrors).length > 0) {
      setValidations(prev => ({ ...prev, ...otpErrors }));
      setLoading(false);
      return;
    }
    setValidations(prev => ({ ...prev, otp: "" }));

    try {

      const res = await axios.post(`${BASE_URL}/account/register`, bodyData);

      if (res.data.code === 200) {
        setInput({
          fname: "",
          lname: "",
          email: "",
          password: "",
          mobile: "",
          otp: "",
          country: "",
          country_code: "",
        });
        MessageToster("success", res.data.message);
        navigate("/");
      } else {
        MessageToster("error", res.data.message);
        const msg = (res.data?.message || "").toLowerCase();
        if (
          msg.includes("email") ||
          msg.includes("already") ||
          msg.includes("exist") ||
          msg.includes("user") ||
          msg.includes("mobile") ||
          msg.includes("phone")
        ) {
          setBeforReg(false);
          setInput(prev => ({ ...prev, otp: "" }));
          if (msg.includes("mobile") || msg.includes("phone")) {
            setValidations(prev => ({ ...prev, mobile: res.data.message }));
          } else {
            setValidations(prev => ({ ...prev, email: res.data.message }));
          }
        }
      }
    } catch (err) {
      MessageToster("error", err.message || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  // const sortedCodeList =
  //   countrycode && countrycode.length > 0 && Array.isArray(countrycode[0])
  //     ? [...countrycode[0]].sort((a, b) =>
  //       a.country_code.localeCompare(b.country_code)
  //     )
  //     : [];

  // console.log(countrycode, "sortedCodeList",)
  useEffect(() => {
    getCountryData()

    const params = new URLSearchParams(location.search);
    const refCode = params.get('ref');

    if (refCode) {
      setInput(prevInput => ({
        ...prevInput,
        refercode: refCode
      }));
    }
  }, [location.search])

  const selectedCountry = Array.isArray(countrycode)
    ? countrycode.find(c => c.country_code === input.country_code)
    : null;

  const countryOptions = Array.isArray(country)
    ? country
        .map((c) => {
          const name = typeof c === "string" ? c : c?.country_name || c?.name || "";
          return { label: name, value: name };
        })
        .filter((item) => item.value)
    : [];

  return (
    <>
      {loading &&
        <Loader />
      }
      <div className="account-pages my-5 pt-sm-5">
        <div className="container">
          <div className="row justify-content-center w-100 mx-auto">
            <div className="col-md-10 col-lg-8 col-xl-7">
              <div className="card" style={{ overflow: "visible" }}>
                <div className="bg-primary-subtle" style={{ borderTopLeftRadius: "inherit", borderTopRightRadius: "inherit" }}>
                  <div className="row align-items-center">
                    <div className="col-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Create Account</h5>
                        <p>Get your free crm account now.</p>
                      </div>
                    </div>
                    <div className="col-5 align-self-end text-end">
                      <img
                        src="assets/images/profile-img.png"
                        alt=""
                        className="img-fluid "
                        width="230px"
                      />
                    </div>
                  </div>
                </div>
                <div className="card-body pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-md-4 mb-3">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src="assets/images/logo.svg"
                            alt=""
                            className="rounded-circle"
                            height={34}
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="needs-validation" >
                    <div className="row">
                      <div className="mb-3 col-12 col-md-6">
                        <label htmlFor="fname" className="form-label">
                          First Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="fname"
                          placeholder="Enter Your First Name"
                          required=""
                          value={input.fname}
                          onChange={handelInputs}
                          name="fname"
                          disabled={loading || beforReg}
                        />
                        {validations.fname && <div className="text-danger">{validations.fname}</div>}
                      </div>
                      <div className="mb-3 col-12 col-md-6">
                        <label htmlFor="lname" className="form-label">
                          Last Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="lname"
                          placeholder="Enter Your Last Name"
                          required=""
                          value={input.lname}
                          onChange={handelInputs}
                          name="lname"
                          disabled={loading || beforReg}
                        />
                        {validations.lname && <div className="text-danger">{validations.lname}</div>}
                      </div>
                      <div className="mb-3 col-12 col-md-6">
                        <label htmlFor="email" className="form-label">
                          Email
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          placeholder="Enter Your email"
                          required=""
                          value={input.email}
                          onChange={handelInputs}
                          name="email"
                          disabled={loading || beforReg}
                        />
                        {validations.email && <div className="text-danger">{validations.email}</div>}
                      </div>

                      <div className="mb-3 col-12 col-md-6">
                        <label htmlFor="password" className="form-label">
                          Password
                        </label>
                        <div className="input-group auth-pass-inputgroup">
                          <input
                            type={showpass ? "text" : "password"}
                            className="form-control"
                            id="password"
                            placeholder="Enter Your password"
                            value={input.password}
                            onChange={handelInputs}
                            name="password"
                            disabled={loading || beforReg}
                          />
                          <button
                            className="btn btn-light "
                            type="button"
                            id="password-addon"
                            onClick={() => setShowpass(!showpass)}
                          >
                            {
                              showpass ?
                                <i className="mdi mdi-eye-outline" />
                                :
                                <i className="mdi mdi-eye-off-outline" />
                            }
                          </button>
                        </div>
                        {validations.password && <div className="text-danger">{validations.password}</div>}

                      </div>

                      <div className="mb-3 col-12 col-md-6">
                        <label htmlFor="mobile" className="form-label">
                          Phone Number
                        </label>
                        <div className="input-group res_main_number">
                          <div className="col-lg-5 col-4">
                            <select
                              className="form-select tel_number"
                              name="country_code"
                              value={input.country_code || ""}
                              onChange={handelInputs}
                              disabled={loading || beforReg}
                            >
                              <option value="" disabled hidden>Code</option>
                              {/* {country && country[0].map((c, index) => (
                                  <option key={index} value={`${c.country_code}`}>
                                    {c.country_code} (+{c.phone_code})
                                  </option>
                                ))} */}
                              {countrycode && countrycode.map((c, index) => (
                                <option key={index} value={c.country_code}>
                                  {c.country_code} (+{c.phone_code})
                                </option>
                              ))}
                            </select>
                          </div>

                          <input
                            type="tel"
                            className="form-control"
                            id="mobile"
                            placeholder="Enter Phone Number"
                            value={input.mobile}
                            onChange={handelInputs}
                            name="mobile"
                            disabled={loading || beforReg || !input.country_code}
                            // disabled={!input.country_code}
                            maxLength={selectedCountry?.phone_code_length || 10}
                          />
                        </div>
                        {validations.country_code && <div className="text-danger">{validations.country_code}</div>}
                        {validations.mobile && <div className="text-danger">{validations.mobile}</div>}
                      </div>

                      <div className="mb-3 col-12 col-md-6">
                        <label htmlFor="country" className="form-label">
                          Country
                        </label>
                        <CustomSelect
                          id="country"
                          name="country"
                          value={input.country}
                          options={countryOptions}
                          onChange={handelInputs}
                          disabled={loading || beforReg}
                          placeholder="Select country"
                          searchable={true}
                          searchPlaceholder="Search country..."
                          hasError={!!validations.country}
                        />
                        {validations.country && (
                          <div className="text-danger small mt-1">{validations.country}</div>
                        )}
                      </div>

                      <div className="mb-3 col-12 col-md-6">
                        <label className="form-label">Referral Code</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Referral Code"
                          name="refercode"
                          // value={ibData.refercode}
                          value={input.refercode}
                          // onChange={handelIBInputs}
                          onChange={handelInputs}
                          disabled={loading || beforReg}
                        />
                        {/* {validations.refercode && <div className="text-danger">{validations.refercode}</div>} */}
                      </div>

                      {/* IB Account Accordion */}
                      <div className="mb-3 col-12">
                        <div className="accordion" id="ibAccordion">
                          <div className="accordion-item border rounded">
                            <h2 className="accordion-header" id="headingIB">
                              <button
                                className={`accordion-button d-flex justify-content-between align-items-center ${showIBFields ? "" : "collapsed"
                                  }`}
                                type="button"
                                onClick={() => setShowIBFields(!showIBFields)}
                                disabled={loading || beforReg}
                              >
                                <span>Add IB Details (Optional)  </span>
                                {/* <span className="accordion-icon" style={{ fontSize: "20px" }}>
                                    {showIBFields ? " −" : " +"}
                                  </span> */}
                              </button>
                            </h2>
                            <div
                              className={`accordion-collapse collapse ${showIBFields ? "show" : ""}`}
                            >
                              <div className="accordion-body">
                                <div className="row">
                                  <div className="mb-3 col-12 col-md-6">
                                    <label className="form-label">IB Name</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter IB Name"
                                      // name="companyName"
                                      // value={input.companyName}
                                      // onChange={handelInputs}
                                      name="ibname"
                                      value={ibData.ibname}
                                      onChange={handelIBInputs}

                                      disabled={loading || beforReg}
                                    />
                                    {validations.ibname && (
                                      <div className="text-danger">{validations.ibname}</div>
                                    )}
                                    {/* {validations.companyName && (
                                        <div className="text-danger">{validations.companyName}</div>
                                      )} */}
                                  </div>

                                  <div className="mb-3 col-12 col-md-6">
                                    <label className="form-label">Year Of Experience</label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      placeholder="Enter Years of Experience"
                                      name="yearofexp"
                                      value={ibData.yearofexp}
                                      onChange={handelIBInputs}
                                      disabled={loading || beforReg}
                                    />
                                    {validations.yearofexp && (
                                      <div className="text-danger">{validations.yearofexp}</div>
                                    )}
                                  </div>

                                  <div className="mb-3 col-12 col-md-6">
                                    <label className="form-label">No. of Existing Clients</label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      placeholder="Enter Existing Clients"
                                      name="existclients"
                                      value={ibData.existclients}
                                      onChange={handelIBInputs}
                                      disabled={loading || beforReg}
                                    />
                                    {validations.existclients && (
                                      <div className="text-danger">{validations.existclients}</div>
                                    )}
                                  </div>

                                  <div className="mb-3 col-12 col-md-6">
                                    <label className="form-label">Average Volume Per Month</label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      placeholder="Enter Avg. Volume Per Month"
                                      name="avgvolume"
                                      value={ibData.avgvolume}
                                      onChange={handelIBInputs}
                                      disabled={loading || beforReg}
                                    />
                                    {validations.avgvolume && (
                                      <div className="text-danger">{validations.avgvolume}</div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>


                      {/* --------------------------------- */}
                      {/* <div className="mb-3 col-12">
                          <div className="accordion" id="ibAccordion">
                            <div className="accordion-item border rounded">
                              <h2 className="accordion-header" id="headingIB">
                                <button
                                  className={`accordion-button ${showIBFields ? "" : "collapsed"}`}
                                  type="button"
                                  onClick={() => setShowIBFields(!showIBFields)}
                                  disabled={beforReg}
                                >
                                  IB Account (Optional)
                                </button>
                              </h2>
                              <div
                                className={`accordion-collapse collapse ${showIBFields ? "show" : ""}`}
                              >
                                <div className="accordion-body">
                                  <div className="row">
                                    <div className="mb-3 col-12 col-md-6">
                                      <label className="form-label">IB Name</label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter IB Name"
                                        name="companyName"
                                        value={input.companyName}
                                        onChange={handelInputs}
                                        disabled={beforReg}
                                      />
                                      {validations.companyName && (
                                        <div className="text-danger">{validations.companyName}</div>
                                      )}
                                    </div>

                                    <div className="mb-3 col-12 col-md-6">
                                      <label className="form-label">Year Of Experience</label>
                                      <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Enter Years of Experience"
                                        name="yearofexp"
                                        value={ibData.yearofexp}
                                        onChange={handelIBInputs}
                                        disabled={beforReg}
                                      />
                                      {validations.yearofexp && (
                                        <div className="text-danger">{validations.yearofexp}</div>
                                      )}
                                    </div>

                                    <div className="mb-3 col-12 col-md-6">
                                      <label className="form-label">No. of Existing Clients</label>
                                      <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Enter Existing Clients"
                                        name="existclients"
                                        value={ibData.existclients}
                                        onChange={handelIBInputs}
                                        disabled={beforReg}
                                      />
                                      {validations.existclients && (
                                        <div className="text-danger">{validations.existclients}</div>
                                      )}
                                    </div>

                                    <div className="mb-3 col-12 col-md-6">
                                      <label className="form-label">Average Volume Per Month</label>
                                      <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Enter Avg. Volume Per Month"
                                        name="avgvolume"
                                        value={ibData.avgvolume}
                                        onChange={handelIBInputs}
                                        disabled={beforReg}
                                      />
                                      {validations.avgvolume && (
                                        <div className="text-danger">{validations.avgvolume}</div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> */}
                      {/* --------------------------------- */}



                      {/* <div className="mb-3 col-12 col-md-6">
                          <label htmlFor="companyName" className="form-label">
                            Company Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="companyName"
                            placeholder="Enter Your Company Name"
                            required=""
                            value={input.companyName}
                            onChange={handelInputs}
                            name="companyName"
                            disabled={beforReg}
                          />
                          {validations.companyName && (
                            <div className="text-danger">{validationRules.companyName}</div>
                          )}
                        </div> */}
                      {
                        beforReg ?
                          <div className="mb-3 col-12 col-md-6">
                            <div className="d-flex justify-content-between align-items-center mb-1">
                              <label htmlFor="otp" className="form-label mb-0">
                                Verify OTP
                              </label>
                              {timer > 0 ? (
                                <span className="text-muted font-size-12">
                                  Resend in <strong className="text-primary">{formatTimer(timer)}</strong>
                                </span>
                              ) : (
                                <button
                                  type="button"
                                  className="btn btn-link p-0 text-primary fw-semibold font-size-12 text-decoration-none"
                                  onClick={handleResendOTP}
                                  disabled={resending || loading}
                                >
                                  {resending ? (
                                    <>
                                      <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" />
                                      Resending...
                                    </>
                                  ) : (
                                    "Resend OTP"
                                  )}
                                </button>
                              )}
                            </div>
                            <input
                              type="tel"
                              maxLength={6}
                              className="form-control"
                              id="otp"
                              placeholder="Enter Your OTP"
                              required=""
                              value={input.otp}
                              onChange={handelInputs}
                              name="otp"
                              disabled={loading || resending}
                            />
                            {validations.otp && <div className="text-danger">{validations.otp}</div>}
                          </div>
                          :
                          ""
                      }
                      <div className="mb-3 mx-3 form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="agreeTerms"
                          checked={agreeTerms}
                          onChange={(e) => setAgreeTerms(e.target.checked)}
                          disabled={loading}
                        />
                        <label className="form-check-label" htmlFor="agreeTerms">
                          I agree to the <Link to="/terms">Terms & Conditions</Link>
                        </label>
                      </div>

                      {beforReg ? (
                        <div className="d-grid">
                          <button
                            type="button"
                            className="btn btn-primary waves-effect waves-light"
                            onClick={submitForm}
                            disabled={loading}
                          >
                            Verify Account
                          </button>
                        </div>
                      ) : (
                        <div className="d-grid">
                          <button
                            type="button"
                            className="btn btn-primary waves-effect waves-light"
                            onClick={handelSubmit}
                            disabled={loading || !agreeTerms}
                          >
                            Register
                          </button>
                        </div>
                      )}

                      <div className="mt-3 text-center">
                        <div>
                          <p>
                            Already have an account ?
                            <Link
                              to="/"
                              className="fw-medium text-primary ps-2"
                            >
                              Login
                            </Link>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  );
}
